import api from './api';

export const authService = {
  login: async (email, password, twoFactorCode = null) => {
    console.log('authService.login called:', { email, hasPassword: !!password, hasCode: !!twoFactorCode });
    // Zwiększony timeout dla logowania (60 sekund) - może wymagać wysłania emaila 2FA
    const response = await api.post('/auth/login', { 
      email, 
      password,
      twoFactorCode 
    }, {
      timeout: 60000 // 60 sekund dla logowania
    });
    
    console.log('authService.login response:', response.data);
    
    // Jeśli wymagany jest kod 2FA, zwróć specjalną odpowiedź
    if (response.data && response.data.requiresTwoFactor) {
      console.log('2FA required, returning special response');
      return {
        requiresTwoFactor: true,
        message: response.data.message || 'Kod weryfikacyjny został wysłany na adres email'
      };
    }
    
    // Normalne logowanie - zapisz token i użytkownika
    if (response.data && response.data.accessToken) {
      localStorage.setItem('token', response.data.accessToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },
  
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
  
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
  
  getStoredUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },
  
  getToken: () => {
    return localStorage.getItem('token');
  },
  
  impersonate: async (userId) => {
    // Zapisz informację o oryginalnym super adminie przed impersonacją
    const userStr = localStorage.getItem('user');
    const currentUser = userStr ? JSON.parse(userStr) : null;
    const currentToken = localStorage.getItem('token');
    
    if (currentUser && currentUser.role === 'SUPERADMIN') {
      localStorage.setItem('originalSuperAdmin', JSON.stringify(currentUser));
      localStorage.setItem('originalSuperAdminToken', currentToken);
    }
    
    const response = await api.post(`/auth/impersonate/${userId}`);
    
    if (response.data && response.data.accessToken) {
      localStorage.setItem('token', response.data.accessToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      // Zapisz informację o impersonacji
      if (response.data.impersonated) {
        localStorage.setItem('impersonatedBy', response.data.impersonatedBy);
      }
    }
    return response.data;
  },
  
  returnToSuperAdmin: async () => {
    const originalSuperAdmin = localStorage.getItem('originalSuperAdmin');
    const originalToken = localStorage.getItem('originalSuperAdminToken');
    
    if (!originalSuperAdmin || !originalToken) {
      throw new Error('Brak informacji o oryginalnym super adminie');
    }
    
    const superAdmin = JSON.parse(originalSuperAdmin);
    
    // Przywróć token i użytkownika super admina
    localStorage.setItem('token', originalToken);
    localStorage.setItem('user', originalSuperAdmin);
    
    // Usuń informacje o impersonacji
    localStorage.removeItem('impersonatedBy');
    localStorage.removeItem('originalSuperAdmin');
    localStorage.removeItem('originalSuperAdminToken');
    
    return {
      accessToken: originalToken,
      user: superAdmin
    };
  },
  
  isImpersonating: () => {
    return !!localStorage.getItem('impersonatedBy');
  },
  
  getOriginalSuperAdmin: () => {
    const originalSuperAdmin = localStorage.getItem('originalSuperAdmin');
    return originalSuperAdmin ? JSON.parse(originalSuperAdmin) : null;
  }
};
